module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-loading",
    attrs: {
      "id": "app-loading"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "warning"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "app-loading-message"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab1c650","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/plugins/loading/AppLoading.vue
// module id = 523
// module chunks = 2